function translateJuicer() {
	$('.j-paginate').text("Cargar más");
}